var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3228,
    cy: 17.4147,
    r: 16.544,
    fill: "url(#pattern0765)",
    stroke: "white",
    strokeWidth: 1.74147
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0765",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_234_6149",
    transform: "scale(0.0138889)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_234_6149",
    width: 72,
    height: 72,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPESURBVHgB7Zw7bxNBEMfHEUgIJHAaRIHEpk0T5wOAHNHQQeio4lSUSToalAg+AKSkAVxRBjo6n6AnoaFC8kWiiGhi3pFAGnZud8157+U7fPY95ieN786+s9d/zcze7asBUwQRm3IjpLWlXdH7Lf2xsE53pQ20HUg7pG2j0XCgSpAo0jal9aQd42ToSetIE1BGLFHypkdiQRnQwmzj5DwlDX392wKKxoyFselL24aiIAvT1oUqGn1pt2BWoPKaR1h8qIxNyEgDMoAqznsQrJqLiittRd4iuJCSOUiJFKctN/tQHnEIIW0fM4RcKoHkD2yA8pzMLjtDqMx78j9sQh6gqqWqwmRrOfmFG1g9xvKkxCSNKm73oJqsJD3bxQqEqraihFzGnDMO9CC8HFe7RQqE6t6hbLVVFlxQIg3CPoyrxSiRCag+AtR/DSXUgyqed6IIzUdRAvWhHt7jx4WQUAuEGKp7BAH1Q0gLVP0jHoQhz1jfT/7Ax6NvkDctMT/c//H7K/S/fIC8WbiwCOdOn/e/Rd6z4PeiU9Y1a2B5D4mz+fQd5I3z4Ppwn8S5/+YO5M2TG29tgajmJi/aMW/YIdYBZgN9zSNDgVC16wpgSJyOOfB70Bowhptmx0vSOjn3o84+GpxAEkeDX4FcRYn33u1FGIdLzTMjx59/fhrruruvr44cXzx7GR5eezHWtXRuDPOUrE2SbsedaRc+DVmvTSh8btf66Eh7bEKMwyuIF2ZGoDYwNi2qzeZQtTEzQbxxBORBLWCiaJNAApgoPA9aAiYKT6CqNqdOgiUWKAHOQfGI1F3PdYMFSoAFSoAEcoGJwmUPimdAAh0AE4Un0CEwUbznHBSPl4McYKI4MB40ACYA9dXP6V5ETtRBHHox1fwrYGy69GIEeg6MjUMvnkA6zBxgDI4Zlue/k+Yw+0fX7AyHv+gOe+pdrXsDmiu9Z8EcDD1Ih9kuMF3/gT2Aqu5e5II16WXkaZ69CLr2mOnAIM4ajY+2Gck9hkB7kPaidagfW2FvhjaY6fHCdQq1XfmfX4Z9wFMREqYi8GSWhMkssW3S+sJVqC7rSfNYExvtdT7aguqxFZV3MiHDbQerww7kAar1OMpOqkm9qefNo5oq9QzKl7gpIa+mXV6HFxZIIFPPqv6hZSjHzSSVcTmLOBOBQg6Lu7hJG4oCqlquj7OHluihshQvR8pCCZydUMUVJgxUa4z1MH96qG4/yvk4hMqrJinW8TRFyVTN/w+oEieN7hegxmg3tQnrVFdvzRKBdOyAatiaWlf5XyWQyfvvjFQGAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarSm);
export default __webpack_public_path__ + "static/media/AvatarSm.7e81d09e9a294127418188892ffca1c9.svg";
export { ForwardRef as ReactComponent };